/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKTypography from "components/MKTypography";

// Material Kit 2 React components
import MKBox from "components/MKBox";

import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// Images
import logo from "assets/images/Spechs_logo/logo_transparent_.png";

import DefaultInfoCard from "reusables/Cards/InfoCards/DefaultInfoCard";

function AboutUs_Section3() {
  return (
    <Container>
      <Grid
        container
        display={"flex"}
        flexDirection={"column"}
        alignItems="center"
        sx={{ mx: "auto" }}
        // bgcolor={"green"}
        width={"100%"}
      >
        <Grid item>
          <SubTitleContents
            title="Our Mission"
            contents="At Spechs, our mission is simple: to deliver outstanding, tailored services that improve the health, safety, and aesthetic appeal of your spaces. We aim to make every environment we serve cleaner, fresher, and healthier."
          />
        </Grid>

        <Grid item>
          <Grid container sx={{ mt: { xs: 0, md: 3 } }} spacing={7}>
            <Grid item xs={12} md={4}>
              <DefaultInfoCard
                icon="thumb_up"
                title="Quality and Excellence"
                description="We consistently deliver top-tier services with a focus on professionalism and detail."
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <DefaultInfoCard
                icon="verified_user"
                title="Reliability"
                description="Our clients trust us to arrive on time, work diligently, and leave their spaces immaculate."
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <DefaultInfoCard
                icon="volunteer_activism"
                title="Respect and Integrity"
                description="We treat every space with care and operate transparently in all aspects of our work."
              />
            </Grid>
          </Grid>
          <Grid container sx={{ mt: { xs: 0, md: 3 } }} spacing={7}>
            <Grid item xs={12} md={4}>
              <DefaultInfoCard
                icon="north_east"
                title="Continuous Improvement"
                description="We regularly enhance our technologies and training to provide exceptional service."
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <DefaultInfoCard
                icon="eco"
                title="Sustainability"
                description="We use eco-friendly products and strive to minimise waste in all our operations."
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <DefaultInfoCard
                icon="support_agent"
                title="Customer-Centric Approach"
                description="We design our services around your unique needs and ensure your satisfaction."
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default AboutUs_Section3;

// // Logo(or rotating card) + Icon version
// /* eslint-disable prettier/prettier */
// /* eslint-disable no-unused-vars */
// import Container from "@mui/material/Container";
// import Grid from "@mui/material/Grid";
// import MKTypography from "components/MKTypography";

// // Material Kit 2 React components
// import MKBox from "components/MKBox";

// // Images
// import logo from "assets/images/Spechs_logo/logo_transparent_.png";

// import DefaultInfoCard from "reusables/Cards/InfoCards/DefaultInfoCard";

// function AboutUs_Section3() {
//   return (
//     <Container>
//       <Grid
//         container
//         alignItems="center"
//         sx={{ mx: "auto" }}
//         // bgcolor={"green"}
//         width={"100%"}
//       >

//         {/* Logo version */}
//         <Grid item xs={12} lg={2} sx={{ mx: "0px" }}>
//           <MKBox
//             component="img"
//             src={logo}
//             alt={"Spech Logo"}
//             width="100%"
//             position="relative"
//             zIndex={1}
//           />

//           {/* Rotating Card version */}
//           {/* <RotatingCard>
//             <RotatingCardFront
//             //   image={logo}
//               icon="touch_app"
//               title={"Discover More"}
//               description="All the MUI components that you need in a development have been re-design with the new look."
//             />
//             <RotatingCardBack
//               image={logo}
//             //   title="About Our Services"
//             //   description="You will save a lot of time going from prototyping to full-functional code because all elements are implemented."
//             //   action={{
//             //     type: "internal",
//             //     route: "/sections/page-sections/page-headers",
//             //     label: "start with header",
//             //   }}
//             />
//           </RotatingCard> */}
//         </Grid>
//         <Grid item xs={12} lg={9} sx={{ ml: "auto" }}>
//           <Grid container>
//             <Grid item xs={12} md={6}>
//               <DefaultInfoCard
//                 icon="event_available"
//                 title="Full Documentation"
//                 description="Built by developers for developers. Check the foundation and you will find
//                     everything inside our documentation."
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <DefaultInfoCard
//                 icon="badge"
//                 title="MUI Ready"
//                 description="The world's most popular react components library for building user interfaces."
//               />
//             </Grid>
//           </Grid>
//           <Grid container sx={{ mt: { xs: 0, md: 6 } }}>
//             <Grid item xs={12} md={6}>
//               <DefaultInfoCard
//                 icon="price_change"
//                 title="Save Time & Money"
//                 description="Creating your design from scratch with dedicated designers can be very expensive. Start with our Design System."
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <DefaultInfoCard
//                 icon="devices"
//                 title="Fully Responsive"
//                 description="Regardless of the screen size, the website content will naturally fit the given resolution."
//               />
//             </Grid>
//           </Grid>
//         </Grid>
//       </Grid>
//     </Container>
//   );
// }

// export default AboutUs_Section3;
